angular.module('bribac.views.addSubject', [
  'ngRoute',
  'bribac.translations',
  'bribac.values',
  'bribac.entities.kinds',
  'bribac.entities.subjectFactory',
  'bribac.services.routeAuth',
  'bribac.components.subjectEditor',
  'bribac.components.subjectDetails'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/add/subject', {
      templateUrl: 'add-subject-view.html',
      controller: 'AddSubjectViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('AddSubjectViewCtrl', function(
    $location,
    KINDS,
    subjectFactory,
    state
  ) {

    var $ctrl = this

    $ctrl.savedEntities = []
    $ctrl.entity = subjectFactory({
      locale: state.currentAgent.locale
    })

    $ctrl.successCallback = function(data) {
      $ctrl.savedEntities.push(data)
      $ctrl.entity = subjectFactory({
        locale: data.locale
      })
    }

  })
